import { TMinMax } from 'types';

export function typeMinMax2Arr({ max, min }: TMinMax): [number, number] {
  return [min, max];
}

export function arr2TypeMinMax([min, max]: [number, number]): TMinMax {
  return { min, max };
}
